//@flow

/**
 * Returns the DOM element based on the itemType (not to be confused with moduleName) and src.
 * @return {HTMLElement}
 */

export default function tracingElementSelector(
  src: string,
  itemType: 'pin' | 'board' | 'interest',
) {
  switch (itemType) {
    case 'interest':
      return document.querySelector('img[src="' + src + '"]');
    case 'board':
      return document.querySelector('div[style*="' + src + '"]');
    default:
      let el = document.querySelector('img[src="' + src + '"]');
      if (!el) {
        // Fall back to srcset
        el = document.querySelector('img[srcset*="' + src + '"]');
      }
      if (!el) {
        // Fall back to srcset
        el = document.querySelector('video[poster="' + src + '"]');
      }
      return el;
  }
}
